import { colors } from "../../data/Colors";

export default class OreCanvas {
  constructor(width, height, ratio = 1) {
    this.canvas = document.createElement("canvas");
    this.setSize(width * ratio, height * ratio);
    if (ratio > 1) {
      this.canvas.style = width;
    }
    this.context = this.canvas.getContext("2d");
    this.setSourceOver();
    this.setupImg();
  }
  setSize(width, height) {
    this.canvas.width = width;
    this.canvas.height = height;
  }
  setupImg() {
    this.img = document.createElement("img");
    this.img.addEventListener("load", () => this.onLoadImg());
  }

  setColor(color) {
    let c;
    if (typeof color == "string") c = color;
    else c = colors[color];
    this.context.fillStyle = c;
  }

  setSourceOver() {
    this.context.globalCompositeOperation = "source-over";
  }
  setDestinationOut() {
    this.context.globalCompositeOperation = "destination-out";
  }

  clear() {
    this.setDestinationOut();
    this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.setSourceOver();
  }

  drawCanvas(srcCanvas) {
    this.setSourceOver();
    this.context.drawImage(srcCanvas, 0, 0);
  }

  captureImage(src, width, height) {
    this.setSourceOver();
    this.context.drawImage(
      src,
      0,
      0,
      src.width,
      src.height,
      0,
      0,
      width,
      height
    );
  }

  drawCanvasText(srcCanvas, width, height, scale, transform) {
    this.setSourceOver();
    // this.context.drawImage(srcCanvas, 0, 0, srcCanvas.width, srcCanvas.height, 0, 0, srcCanvas.width, srcCanvas.height);
    let s = scale - 1;
    // ぜんぜんうまくいかん。scaleがでかいと切り取られたりする…。なんなんまじで。
    this.context.drawImage(
      srcCanvas,
      0,
      0,
      srcCanvas.width,
      srcCanvas.height,
      width * s,
      height * s,
      // transform.x,
      // transform.y,
      width / scale,
      height / scale
    );
  }

  /**
   * textLayer.toCanvas()したやつ
   * @param srcCanvas
   * @param width
   * @param height
   * @param scale
   * @param transform
   */
  drawCanvasText2(srcCanvas, width, height, scale, transform, rect) {
    console.log("rect", rect);
    this.setSourceOver();
    let s = Math.pow(scale, 2);
    this.context.drawImage(
      srcCanvas,
      0,
      0,
      srcCanvas.width,
      srcCanvas.height,
      rect.x / scale,
      rect.y / scale,
      // transform.x,
      // transform.y,
      srcCanvas.width / s,
      srcCanvas.height / s
    );
  }
  drawCanvasText3(srcCanvas) {
    this.setSourceOver();
    //セーフエリアみたいなんを設定しないとNG
    let expand = 10;
    // this.context.strokeStyle = "red";
    // this.context.strokeRect(0, 0, 100, 100);
    console.log("srcCanvas.width", srcCanvas.width, srcCanvas);
    const width = 600 + expand;
    const height = 600 + expand;

    this.context.drawImage(srcCanvas, 0, 0, width, height, 0, 0, width, height);
  }

  outline() {
    this.context.lineWidth = 10;
    this.context.strokeRect(0, 0, this.canvas.width, this.canvas.height);
  }

  getBase64() {
    return this.canvas.toDataURL("image/png");
  }
  getResizedBase64(width, height) {
    // とりあえずリサイズしないので、元のcanvasから取得してみる
    // return this.canvas.toDataURL("image/png");

    // 色が変わる？？？？
    const resizedCanvas = document.createElement("canvas");
    const resizedContext = resizedCanvas.getContext("2d");
    resizedCanvas.height = height;
    resizedCanvas.width = width;
    resizedContext.drawImage(this.canvas, 0, 0, width, height);
    return resizedCanvas.toDataURL("image/png");
  }

  setBase64(base64, callback) {
    this.img.src = base64;
    this.callback = callback;
  }
  onLoadImg() {
    this.clear();
    this.context.drawImage(this.img, 0, 0);
    if (this.callback) this.callback();
    this.callback = null;
    this.img.src = "";
  }
}
